import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
// import invoice from "../Assets/invoice.png";
import WarrCard from "../warrCard/warrCard";
// import { APICall } from "../api";
import {
  ax_claim_getInvoiceFile,
  ax_warranty_updateIssueWithWarranty,
} from "../api/claim";
import toast from "react-hot-toast";
import { ArrRefresh2O } from "lovedicons/dist/arrO";
import Modal from "../component/Modal";
// import axios from "axios";
import { fetchClaimRecord } from "../api/auth";

const InputField = ({ label, value, readOnly = true }) => (
  <div className="flex-grow border-gray border-2 p-2 rounded-lg">
    <label className="block text-gray-500 text-sm">{label}</label>
    <input
      type="text"
      value={value}
      className="w-full outline-none border-gray-300"
      readOnly={readOnly}
    />
  </div>
);

const TwoColumnRow = ({ fields }) => (
  <div className="flex flex-row w-full gap-3">
    {fields.map((field, index) => (
      <InputField key={index} {...field} />
    ))}
  </div>
);

const ThreeColumnRow = ({ fields }) => (
  <div className="flex flex-row w-full gap-2">
    {fields.map((field, index) => (
      <InputField key={index} {...field} />
    ))}
  </div>
);

const WarrantyClaim = ({ selectedClaim, createdFromBrand }) => {
  const statusColors = {
    approved: "text-green-500",
    resolved: "text-green-500",
    rejected: "text-red-500",
    pending: "text-orange-500",
  };
  // console.log("selectedClaim", selectedClaim);

  const navigate = useNavigate();
  const [showImages, setShowImages] = useState(false);
  const [invoiceWarr, setInvoiceWarr] = useState();

  const [imageFiles, setImageFiles] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [clickedBtn, setClickedBtn] = useState("");

  const handleViewImages = async () => {
    try {
      const axGetImages = await ax_claim_getInvoiceFile(selectedClaim?._id);

      if (axGetImages.data) {
        if (axGetImages.data.frameNo === selectedClaim?.frameNo) {
          console.log("axGe - ", axGetImages);
          setImageFiles(axGetImages.data.images);
          setShowImages(true);
        } else {
          toast.error("Invoice file not found!");
        }
      }
    } catch (error) {
      console.error("Error fetching invoice file:", error);
      toast.error("Failed to fetch the invoice file!");
    }
  };
  const handleCloseInvoice = () => setShowImages(false);
  const getId = selectedClaim?.warrantyFormID?._id;

  const [comments, setComments] = useState("" || selectedClaim?.comments);

  // console.log("getId", getId);

  useEffect(() => {
    const getSelected = async () => {
      await fetchClaimRecord(getId, setInvoiceWarr);
    };

    getSelected();
  }, [getId, invoiceWarr]);

  // function handleBase64File(base64String) {
  //   // if (!base64String.includes(",")) {
  //   //   console.error("Invalid Base64 format: Missing comma separator.");
  //   //   return null;
  //   // }

  //   if (!base64String.includes(",")) {
  //     // Assume the base64 string is raw image data (e.g., PNG)
  //     base64String = `data:image/png;base64,${base64String}`;
  //   }

  //   const [prefix, base64Data] = base64String.split(",");
  //   const mimeTypeMatch = prefix.match(/:(.*?);/);

  //   if (!mimeTypeMatch) {
  //     console.error("MIME type not found in Base64 string.");
  //     return null;
  //   }

  //   const mimeType = mimeTypeMatch[1]; // Extract MIME type

  //   // Validate the MIME type for supported formats (image/png, image/jpeg, application/pdf)
  //   const validMimeTypes = ["image/png", "image/jpeg", "application/pdf"];
  //   if (!validMimeTypes.includes(mimeType)) {
  //     console.error(
  //       `Unsupported file type: ${mimeType}. Only PNG, JPEG, and PDF are supported.`
  //     );
  //     return null;
  //   }

  //   // Validate Base64 content
  //   try {
  //     const byteCharacters = atob(base64Data);
  //     const byteNumbers = new Array(byteCharacters.length);

  //     for (let i = 0; i < byteCharacters.length; i++) {
  //       byteNumbers[i] = byteCharacters.charCodeAt(i);
  //     }

  //     const byteArray = new Uint8Array(byteNumbers);
  //     const blob = new Blob([byteArray], { type: mimeType });
  //     const blobUrl = URL.createObjectURL(blob);

  //     return { mimeType, blobUrl };
  //   } catch (error) {
  //     console.error("Error decoding Base64 content:", error);
  //     return null;
  //   }
  // }

  // function handleBase64File(base64String) {
  //   if (!base64String.includes(",")) {
  //     console.error("Invalid Base64 format");
  //     return null;
  //   }

  //   const [prefix, base64Data] = base64String.split(",");
  //   const mimeTypeMatch = prefix.match(/:(.*?);/);

  //   if (!mimeTypeMatch) {
  //     console.error("MIME type not found");
  //     return null;
  //   }

  //   const mimeType = mimeTypeMatch[1]; // Extract MIME type
  //   const byteCharacters = atob(base64Data);
  //   const byteNumbers = new Array(byteCharacters.length);

  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }

  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: mimeType });
  //   const blobUrl = URL.createObjectURL(blob);

  //   return { mimeType, blobUrl };
  // }

  const onApproveResolveRejectClick = async (
    _id,
    approvalStatus,
    selectedClaim
  ) => {
    if (!selectedClaim) return;
    // console.log("selectedClaim?._id - ", selectedClaim?._id);

    const { frameNo, wowNo, createdFromBrand } = selectedClaim;
    const name = selectedClaim?.warrantyFormID?.name;
    const email = selectedClaim?.warrantyFormID?.email;

    const payload = {
      warrStatus:
        approvalStatus === "Approve"
          ? "Approved"
          : approvalStatus === "Resolve"
          ? "Resolved"
          : "Rejected",
      email,
      name,
      wowNo,
      frameNo,
      createdFromBrand,
      comments,
    };

    try {
      setIsLoading(true);
      setClickedBtn(approvalStatus);
      const res = await ax_warranty_updateIssueWithWarranty(_id, payload);

      // console.log("res -", res);
      // console.log("payload -", payload);

      if (res) {
        setIsLoading(false);
        setClickedBtn("");
        navigate("/claimList");
        toast.success(res?.description);
      }
    } catch (error) {
      console.error("Error updating warranty:", error);
      setIsLoading(false);
      setClickedBtn("");
    }
  };
  // console.log("selectedClaim", selectedClaim);

  return (
    <main className="ml-4 p-6 w-full flex bg-white rounded-lg">
      <main className="w-full">
        <header className="flex justify-between items-center mb-6">
          <div className="flex flex-row gap-6 items-center">
            <div onClick={() => navigate(-1)}>
              <svg
                className="cursor-pointer"
                width="7"
                height="17"
                viewBox="0 0 7 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.875 1.25C-0.625 8.75 -0.625 8.75 5.875 15.75"
                  stroke="black"
                  strokeOpacity="0.5"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-semibold">Warranty Claim</h1>
          </div>

          <div className="space-x-2 flex items-center">
            <div className="mr-3">
              Status:
              <span
                className={`py-1.5 px-2 ml-2 bg-gray-100 font-semibold shadow-md rounded-full ${
                  statusColors[selectedClaim?.warrStatus?.toLowerCase()]
                }`}
              >
                {selectedClaim?.warrStatus}
              </span>
            </div>

            {selectedClaim?.warrStatus !== "Resolved" && (
              <>
                {selectedClaim?.warrStatus === "Approved" ? (
                  <button
                    className="px-4 py-2 bg-green-300 text-black rounded-md hover:bg-green-400 font-semibold"
                    onClick={() =>
                      onApproveResolveRejectClick(
                        selectedClaim?._id,
                        "Resolve",
                        selectedClaim
                      )
                    }
                  >
                    {isLoading && clickedBtn === "Resolve" ? (
                      <div className="w-full">
                        <ArrRefresh2O className="w-5 h-5 animate-spin" />
                      </div>
                    ) : (
                      "Resolve"
                    )}
                  </button>
                ) : (
                  <button
                    className="px-4 py-2 bg-green-300 text-black rounded-md hover:bg-green-400 font-semibold"
                    onClick={() =>
                      onApproveResolveRejectClick(
                        selectedClaim?._id,
                        "Approve",
                        selectedClaim
                      )
                    }
                  >
                    {isLoading && clickedBtn === "Approve" ? (
                      <div className="w-full">
                        <ArrRefresh2O className="w-5 h-5 animate-spin" />
                      </div>
                    ) : (
                      "Approve"
                    )}
                  </button>
                )}

                <button
                  className="px-4 py-2 bg-red-300 text-gray-800 rounded-md hover:bg-red-400 font-semibold"
                  onClick={() =>
                    onApproveResolveRejectClick(
                      selectedClaim?._id,
                      "Reject",
                      selectedClaim
                    )
                  }
                >
                  {isLoading && clickedBtn === "Reject" ? (
                    <div className="w-full">
                      <ArrRefresh2O className="w-5 h-5 animate-spin" />
                    </div>
                  ) : (
                    "Reject"
                  )}
                </button>
              </>
            )}
          </div>
        </header>

        <main className="flex flex-row gap-6">
          <section className="bg-white p-6 rounded-lg shadow-md w-full">
            <form className="flex flex-col gap-4">
              <InputField
                label="Name"
                value={selectedClaim?.warrantyFormID?.name}
              />
              <TwoColumnRow
                fields={[
                  { label: "Wow No", value: selectedClaim?.wowNo },
                  { label: "Frame Number", value: selectedClaim?.frameNo },
                ]}
              />
              <ThreeColumnRow
                fields={[
                  {
                    label: "Brand",
                    value:
                      selectedClaim?.brand ||
                      selectedClaim?.warrantyFormID?.brand,
                  },
                  {
                    label: "Source of Purchase",
                    value:
                      selectedClaim?.sourceOfPurchase ||
                      selectedClaim?.warrantyFormID?.sourceOfPurchase,
                  },
                  { label: "Claim Date", value: selectedClaim?.purchaseDate },
                ]}
              />
            </form>
            <textarea
              name="comment"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              placeholder="Write something..."
              className="p-2 w-full h-40 mt-5 border-2 border-[#e5e7eb] rounded-lg resize-none"
            ></textarea>
            <div className="mt-3 flex justify-end">
              <button
                onClick={handleViewImages}
                className="bg-gray-800 text-white px-6 py-2 rounded-lg hover:bg-gray-700"
              >
                View Images
              </button>
            </div>
            {/* {JSON.stringify(imageFiles)} */}
            <Modal isOpen={showImages} onClose={handleCloseInvoice}>
              <div className="p-4 h-full flex flex-col items-center justify-center object-scale-down">
                {imageFiles && imageFiles.length > 0 ? (
                  <div
                    className={`grid ${
                      imageFiles.length > 1 ? "grid-cols-2" : "grid-cols-1"
                    } gap-4`}
                  >
                    {imageFiles.map((image, index) => {
                      return (
                        <img
                          key={index}
                          src={image}
                          alt="Invoice File"
                          // className="max-w-full max-h-full object-scale-down"
                          className="w-full h-24 md:h-36 lg:h-56 xl:h-52 object-contain"
                        />
                      );
                    })}
                  </div>
                ) : (
                  <p>No invoice available</p>
                )}
              </div>
            </Modal>
          </section>
          <WarrCard
            selectedWarranty={selectedClaim}
            createdFromBrand={createdFromBrand}
          />
        </main>
      </main>
    </main>
  );
};

export default WarrantyClaim;
